import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { obrigacoesModuleName, obrigacoesStorage } from "../shared/data.service";
import { Obrigacao } from "../shared/obrigacao.model";
import { Frota } from "../../../bens/frotas/shared/frota.model";
import { ObrigacaoNavigationService } from "../shared/obrigacao-navigation.service";
import { ObrigacaoApiService } from "../shared/obrigacao-api.service";
import { Obrigacoeservice } from "../shared/obrigacao.service";
import { UtilService } from "../../../shared/services/util.service";
import { editRoute, newRouteFemale } from "../../../shared/services/data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { FrotaApiService } from "../../../bens/frotas/shared/frota-api.service";
import { FrotasService } from "../../../bens/frotas/shared/frota.service";
import { frotasQuery } from "../../../bens/frotas/shared/data.service";
import { TipoObrigacao } from "../obrigacao-tipos/shared/obrigacao-tipo.model";
import { obrigacaoTiposQuery, obrigacaoTiposStorage } from "../obrigacao-tipos/shared/data.service";
import { ObrigacaoTipoNavigationService } from "../obrigacao-tipos/shared/obrigacao-tipo-navigation.service";
import { ObrigacaoTipoApiService } from "../obrigacao-tipos/shared/obrigacao-tipo-api.service";

@Component({
    selector: 'app-obrigacao-form',
    template: require('./obrigacao-form.component.html'),
    styles: [require('./obrigacao-form.component.css')]
})
export class ObrigacaoFormComponent implements OnInit {
    obrigacaoModule: any = obrigacoesModuleName;
    formObject: any = new Obrigacao();
    obrigacaoTipoObject: any = new TipoObrigacao();
    frotaObject: any = new Frota();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;

    frotaSelectId: string = 'frota';
    frotaQuery: any = frotasQuery;
    obrigacaoTipoSelectId: string = 'obrigacaoTipo';
    obrigacaoTipoQuery: any = obrigacaoTiposQuery;

    form: FormGroup;
    ativo = new FormControl('');
    dataPagamento = new FormControl('');
    dataVencimento = new FormControl('', Validators.required);
    tipoObrigacao = new FormControl('', Validators.required);
    frota = new FormControl('', Validators.required);
    observacao = new FormControl('');
    valor = new FormControl('', Validators.required);

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseObrigacao: any;

    constructor(
        private _route: ActivatedRoute,
        private _obrigacaoNavigationService: ObrigacaoNavigationService,
        private _obrigacaoApiService: ObrigacaoApiService,
        private _obrigacoeservice: Obrigacoeservice,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _obrigacaoTipoNavigationService: ObrigacaoTipoNavigationService,
        private _obrigacaoTipoApiService: ObrigacaoTipoApiService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            dataPagamento: this.dataPagamento,
            dataVencimento: this.dataVencimento,
            tipoObrigacao: this.tipoObrigacao,
            frota: this.frota,
            observacao: this.observacao,
            valor: this.valor
        });
    }

    ngOnInit() {
        this.testSession();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    keyupCurrency(start?: boolean) {
        const valor: number = this._utilService.currencyFormat(this.formObject.valor, start);
        if (valor) {
            this.formObject.valor = valor;
        }
    }

    onSubmit(evt) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.obrigacaoTipoObject.id) {
                object.tipoObrigacaoId = this.obrigacaoTipoObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.frotaObject.id) {
                object.bemId = this.frotaObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            var date:any = document.getElementById('dataVencimento');
            if (date.value) {
                object.dataVencimento = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataVencimento = null;
            }

            date = document.getElementById('dataPagamento');
            if (date.value) {
                object.dataPagamento = this._utilService.convertStringToDate(date.value);
            } else {
                object.dataPagamento = null;
            }

            if (object.valor) {
                object.valor = this._utilService.getCurrency(object.valor);
            }

            if (object.id) {
                this.onEditObrigacao(object);
            } else {
                this.onAddObrigacao(object);
            }
        }
    }

    getFrotasObject(object) {
        this.frotaObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'frota', object);
    }

    frotaTemplateResult = (function(state: any) {
        var template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    getObrigacaoTipoObject(object) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._obrigacoeservice.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                titulo: object.text,
                form: obrigacoesStorage
            };

            this._autocompleteService.setSessionStorage(toOtherFormObject, obrigacaoTiposStorage);
            this._obrigacaoTipoNavigationService.goToNew();
        } else {
            this.obrigacaoTipoObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'tipoObrigacao', object);
        }
    }

    private onAddObrigacao(object: Obrigacao) {
        this._obrigacaoApiService.onPost(object, this.onDone);
    }

    private onEditObrigacao(object: Obrigacao) {
        this._obrigacaoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response) {
        if (!Response.error)  {
            this.responseObrigacao = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();

            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma obrigação encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._obrigacaoApiService.onGetById(id, onDone);
    }

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.bem = this.frotaObject;
        object.tipoObrigacao = this.obrigacaoTipoObject;

        if (this.formObject.valor) {
            object.valor = this._utilService.getCurrency(this.formObject.valor);
        }

        return object;
    }

    private testSession() {
        var id: number;
        var session: any = this._obrigacoeservice.getSessionStorage();
        this._obrigacoeservice.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private setModelToForm() {
        this.keyupCurrency(true);

        if (this.formObject.bem) {
            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
            delete this.formObject['bem'];

            var placa: string = '';
            if (this.frotaObject.placa) {
                placa = this.frotaObject.placa + ' / ';
            }

            var selectObject:any = {text: placa.concat(this.frotaObject.identificacao), id: this.frotaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'frota', this.frotaObject);
        }

        if (this.formObject.tipoObrigacao) {
            this.obrigacaoTipoObject = this._utilService.cloneObject(this.formObject.tipoObrigacao);
            delete this.formObject['tipoObrigacao'];

            var selectObject:any = {text: this.obrigacaoTipoObject.titulo, id: this.obrigacaoTipoObject.id};

            this._autocompleteService.createOptionOnSelect2(this.obrigacaoTipoSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.obrigacaoTipoSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'tipoObrigacao', this.obrigacaoTipoObject);
        }

        if (this.formObject.dataPagamento) {
            if (this.formObject.dataPagamento.indexOf("/") === -1) {
                this.formObject.dataPagamento = this._utilService.convertDateToString(this.formObject.dataPagamento);
            }
        }

        if (this.formObject.dataVencimento) {
            if (this.formObject.dataVencimento.indexOf("/") === -1) {
                this.formObject.dataVencimento = this._utilService.convertDateToString(this.formObject.dataVencimento);
            }
        }
    }

    private goToList() {
        this._obrigacaoNavigationService.goToList();
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._obrigacoeservice.returnToOtherForm(this.otherForm, this.responseObrigacao);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-form/obrigacao-form.component.ts
 **/